export default __webpack_public_path__ + "static/media/UssdHero.c9afcb33.svg";